import FeatureCard from "./FeatureCard";
import { motion } from "framer-motion";
import icon1 from "../assets/Icon-1.png";
import icon2 from "../assets/Icon-2.png";
import icon3 from "../assets/Icon-3.png";
import icon4 from "../assets/Icon-4.png";
import { Helmet } from "react-helmet-async";




export default function Highlight() {
  const icons = [icon1, icon2, icon3, icon4];

  const features = [
    {
      
      title: "Slot Games with Over 50 Unique Features",
      color: "text-black",
      features: [
        { title: "Wide Range of Features", description: "Our slot games come equipped with more than 50 different types of features, ensuring a dynamic and engaging experience." },
        { title: "Flexible Game Configuration", description: " Customize jackpots, bet limits, payout structures, and RTP with just a few clicks." },
      ],
    },
    {
      

      title: "Full Kiosk Integration",
      color: "text-black",
      features: [
        { title: "Cashout & Voucher Systems", description: "Players can easily cash out and print vouchers for a seamless experience." },
        { title: "Receipt Printing", description: "Advanced printers generate detailed receipts for every transaction." },
      ],
    },
    {
    

      title: "User-Friendly Admin Platform",
      color: "text-black",
      features: [
        { title: "Efficient Customer Management", description: "Easily manage customer data with a streamlined interface." },
        { title: "Advanced Terminal Configuration", description: "Control slot machine settings (terminal IDs, serial numbers, etc.)." },
        { title: "Real-Time Reports", description: "Detailed insights into player activity, game performance, and financial metrics." },
      ],
    },
    {
      

      title: "Comprehensive Hardware Integration",
      color: "text-black",
      features: [
        { title: "Bill Acceptors", description: "JCM UBA 1055, MEI SC Advance, GBA GV1, etc." },
        { title: "Printer Integration", description: "Transact Epic Edge & Epic 950 for smooth printing." },
        { title: "Quixant Boards", description: "Optimal performance for graphics, logic, and device control." },
        { title: "Security Features", description: "Advanced security and reliable metrics." },
      ],
    },
  ];

  return (
    <motion.section className="mb-1 ">
      <div>
<Helmet>
        {/* <title>Land Slot Game Services | Custom Slot Game Development</title>
        <meta name="description" content="Expert land slot game development services, including custom game design, and integration. Boost your casino with premium slot solutions!" /> */}
        {/* <meta name="keywords" content="slots, slot games, online slots, casino slots, jackpot" />
        <meta property="og:title" content="Play Exciting Slot Games" />
        <meta property="og:description" content="Try your luck with our top-rated online slots!" />
        <meta property="og:image" content="https://example.com/slots-banner.jpg" /> */}
      </Helmet>


      <h2 className="text-3xl md:text-[2.6rem] font-bold  mb-2 sm:mb-6 lg:mb-14 z-40 relative min-h-[3rem] bg-black text-transparent bg-clip-text  ">
        Key Highlights
      </h2>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-6 lg:mx-32">
        {features.map((feature, index) => (

          <FeatureCard key={index} {...feature} icon={icons[index % icons.length]} />
        ))}
      </div>
      </div>
   
    </motion.section>
  );
}
